import { Component, OnInit, Input } from '@angular/core';

import { ChartService } from '../../services/chart.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'spam-body-output',
  templateUrl: './spam-body-output.component.html'
})
export class SpamBodyOutputComponent implements OnInit {

  classifyData: any;
  spamBodyChart: any;
  hasData: boolean = false;
  showVerbose: boolean = false;

  @Input()
  set data(data: any) {
    this.classifyData = data;
    this.updateView();
  }

  constructor(private chartService: ChartService,
              private utilService: UtilService) {
    this.spamBodyChart = this.chartService.defaultChart;
    this.spamBodyChart.chart.type = 'bar';
    this.spamBodyChart.chart.height = '260';
    this.spamBodyChart.legend.enabled = false;
    this.spamBodyChart.yAxis.title = {
      text: 'Category probability'
    };
    this.spamBodyChart.xAxis.labels = {
      style: {
        fontSize: '14px'
      }
    };

    this.spamBodyChart.yAxis.labels = {
      style: {
        fontSize: '14px'
      },
      format: '{value}%'
    };
  }

  ngOnInit() {
  }

  updateView() {
    this.hasData = false;
    this.spamBodyChart.series = [{data:[]}];
    this.spamBodyChart.xAxis.categories = [];
    var idx=0;

    if (this.classifyData) {
      this.classifyData.forEach((category) => {
        var color = this.chartService.toneColors[0];
        if (category.c == 'spam') {
          color = this.chartService.toneColors[2];
        }
        this.spamBodyChart.xAxis.categories.push(category.c);
        this.spamBodyChart.series[0].data.push({
          name: category.c,
          color: color,
          y: this.utilService.roundDecimal(category.p*100, 2)
        });
      });
      this.hasData = true;
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/classify-output/spam-body-output.component.ts